import { Wording } from '@/types';

export const ASTROLOGY_WORDING_DE: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Meditationen',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Anleitungen',
  components_header_text2: 'Der Blog',
  components_header_members: 'Mitglieder',
  hero_text: 'Erforsche die Sterne in deinem Inneren',
  hero_button_text: 'Hier beginnen',
  components_ressources_section_title: 'RESSOURCEN',
  components_ressources_subheader_text: 'Alle Werkzeuge, die Sie für kosmische Erkenntnisse und Selbstfindung benötigen',
  components_ressources_span_text: 'Erweitern Sie Ihr inneres Universum mit einer kuratierten Mischung aus Podcasts und Artikeln. Ob Sie kosmische Erkenntnisse, Klarheit oder spirituelle Ausrichtung suchen – unsere Ressourcen helfen Ihnen, sich auf praktische und sinnvolle Weise mit der Astrologie zu verbinden.',
  components_ressources_card_1_title: 'Tieftauchgänge',
  components_ressources_card_1_text: 'Tauchen Sie ein in eine umfangreiche Sammlung ausführlicher Podcasts zu den Themen Astrologie, Tarot, kosmische Archetypen und spirituelles Wachstum – konzipiert, um Ihr Bewusstsein zu erweitern und Ihre Praxis zu vertiefen.',
  components_ressources_card_2_title: 'Star Insights',
  components_ressources_card_2_text: 'Astrologische Tipps und Blogbeiträge zur Selbsterkenntnis und seelischen Weiterentwicklung.',
  components_ressources_link: 'Erfahren Sie mehr',
  components_notes_and_google_title_1: 'Astrologische Beratung',
  components_notes_and_google_title_2: 'Kosmische Routine',
  components_notes_and_google_title_3: 'Reflexionen',
  components_review_google_text: 'Bewertungen',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Unser Podcast',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Weitere Folgen',
  text2_section_title: 'Ratgeber',
  text2_section_subheader_text: 'Artikel & Einblicke',
  text2_section_button_more: 'Mehr laden',
  components_text1_section_title: 'LEITFADEN',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Alle Anleitungen anzeigen',
  components_footer_text: 'Erwecke deinen inneren Kosmos: Dein Weg, deine Sterne.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registrierungsnummer',
  components_footer_legal: 'Rechtliches',
  components_footer_terms: 'Geschäftsbedingungen',
  components_footer_privacy: 'Datenschutzrichtlinie',
  button_load_more: 'Mehr laden',
  page_media_1_content_hero_text: 'Podcast-Episoden',
  page_media_content_menu_foundations: 'Stiftungen',
  page_media_content_menu_spirituality: 'Spiritualität',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psychologie',
  page_media_content_menu_trends: 'Trends',
  page_media_2_content_hero_text: 'Medien 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Unser Blog',
  page_text2_section_title: 'Der Blog',
  page_text2_subheader_text: 'Artikel & Einblicke',
  enter_email_title: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um fortzufahren',
  enter_email_placeholder_email: 'E-Mail',
  enter_email_button_enter: 'Eingeben',
  components_login_success_text: 'Erfolgreich angemeldet!',
  components_card_link_media_content: 'Jetzt anhören',
  components_card_link_text1_content: 'Leitfaden anzeigen',
  components_card_link_text2_content: 'Artikel anzeigen',
  france: 'Frankreich',
  cyprus: 'Zypern',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditation',
  page_media_content_menu_all: 'Alle',
};